import { IApplicationState } from '../../types/redux';
import { getAnswerById } from './getAnswerById';

export const getAnswerAuthorById = (id: string) => (state: IApplicationState) => {
  const answer = getAnswerById(id)(state);

  return answer?.user?.name || '';
};
